import mobile from './mobileComponents';
import desktop from './desktopComponents';
import { PlatformInterface } from './types';
import { isMobile } from '../../util/ismobile';

const Platform: PlatformInterface = isMobile() ? mobile : desktop;

export default Platform;
